export default __webpack_public_path__ + "static/media/(37).ddb86a05.JPG";